export class AutorizzazioneVO {
  codice: string;

  nome: string;
}
